<script setup lang="ts">
import { computed } from 'vue'
import { VBadge, VIcon } from '@/modules/shared/components'
import { type Status } from '../types'

const props = defineProps<{
  status: Status
}>()

const state = computed(() => {
  switch (props.status) {
    case 'queued':
      return {
        color: 'gray',
        icon: 'hourglass-01',
        label: 'AML Queued',
      }
    case 'cleared':
      return {
        color: 'v-green',
        icon: 'shield-tick',
        label: 'AML Cleared',
      }
    case 'pending_review':
      return {
        color: 'amber',
        icon: 'flag-02',
        label: 'AML Pending Review',
      }
    case 'false_positive':
      return {
        color: 'v-green',
        icon: 'shield-tick',
        label: 'AML Cleared *',
      }
    case 'confirmed_match':
      return {
        color: 'red',
        icon: 'slash-circle-01',
        label: 'AML Confirmed Match',
      }
  }
})
</script>

<template>
  <VBadge v-if="status" :color="state.color" class="flex items-center gap-1">
    <VIcon :name="state.icon" class="block h-4 w-4" />
    <span>{{ state.label }}</span>
  </VBadge>
</template>
